import { render, staticRenderFns } from "./GuideforMarket.vue?vue&type=template&id=f456e986&scoped=true"
import script from "./GuideforMarket.vue?vue&type=script&lang=js"
export * from "./GuideforMarket.vue?vue&type=script&lang=js"
import style0 from "./GuideforMarket.vue?vue&type=style&index=0&id=f456e986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f456e986",
  null
  
)

export default component.exports